import { call, put, takeEvery, takeLatest } from 'redux-saga/effects';

import { templatesActions } from '../actions/templates';
import * as api from '../api/templates';

const {
  templatesListAll,
  templatesListAllSucceeded,
  templatesListAllFailed,
  templatesAdd,
  templatesAddSucceeded,
  templatesAddFailed,
  templatesDelete,
  templatesDeleteSucceeded,
  templatesDeleteFailed,
  templatesUpdate,
  templatesUpdateSucceeded,
  templatesUpdateFailed,
  templatesRender,
  templatesRenderSucceeded,
  templatesRenderFailed,
  templatesGetSort,
  templatesGetSortSucceeded,
  templatesGetSortFailed,
  templatesSetSort,
  templatesSetSortSucceeded,
  templatesSetSortFailed,
} = templatesActions;

export const templates = [
  takeLatest(
    templatesListAll.toString() as any,
    genWithPromise(
      api.getAll,
      templatesListAllSucceeded,
      templatesListAllFailed,
    ),
  ),
  takeLatest(
    templatesAdd.toString() as any,
    genWithPromise(api.addById, templatesAddSucceeded, templatesAddFailed),
  ),
  takeLatest(
    templatesDelete.toString() as any,
    genWithPromise(
      api.deleteTemplateById,
      templatesDeleteSucceeded,
      templatesDeleteFailed,
    ),
  ),
  takeLatest(
    templatesUpdate.toString() as any,
    genWithPromise(
      api.updateById,
      templatesUpdateSucceeded,
      templatesUpdateFailed,
    ),
  ),
  takeEvery(
    templatesRender.toString() as any,
    genWithPromise(api.render, templatesRenderSucceeded, templatesRenderFailed),
  ),
  takeLatest(
    templatesGetSort.toString() as any,
    genWithPromise(
      api.getSortTemplate,
      templatesGetSortSucceeded,
      templatesGetSortFailed,
    ),
  ),
  takeLatest(
    templatesSetSort.toString() as any,
    genWithPromise(
      api.setSortTemplate,
      templatesSetSortSucceeded,
      templatesSetSortFailed,
    ),
  ),
];

function genWithPromise(
  apiAction: (action: any) => any,
  resultSucceededAction: (result: any) => any,
  resultFailedAction: (result: any) => any,
) {
  return function* (action: {
    payload: any;
    meta: { resolve: () => void; reject: () => void };
  }) {
    let result;

    try {
      result = yield call(apiAction, action.payload);
      yield call(action.meta.resolve as any, result);
      yield put(resultSucceededAction(result));
    } catch (exception) {
      console.warn(exception);
      // Something went wrong. We reject the promise.
      yield call(action.meta.reject as any, exception);
      result = exception;
      yield put(resultFailedAction(result));
    }
  };
}
